const BOTTOM_TABS = ['geofence_triggers', 'job_events', 'location_histories'] as const;

export type BottomTab = (typeof BOTTOM_TABS)[number];

export const LOCATION_HISTORIES_PAGE_SIZE = 20;

export function isBottomTab(value: string | undefined): value is BottomTab {
  return BOTTOM_TABS.includes(value as BottomTab);
}

export function parsePage(value: string | undefined): number | null {
  if (value === undefined) return null;
  if (!/^\d+$/.test(value)) return null;
  const n = parseInt(value, 10);
  return n >= 1 ? n : null;
}
